import { useState } from 'react'
import { Head } from '@inertiajs/react'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import DecisionEditorDialog from '@/frontend/features/Fde/DecisionEditorDialog'
import DecisionLog from '@/frontend/features/Fde/DecisionLog'
import FdeShell from '@/frontend/features/Fde/FdeShell'
import ForgePane from '@/frontend/features/Fde/ForgePane'
import ForgeStage from '@/frontend/features/Fde/ForgeStage'
import ProjectControls from '@/frontend/features/Fde/ProjectControls'
import ProjectDialog from '@/frontend/features/Fde/ProjectDialog'
import type { Decision, DecisionsProps, Project } from '@/frontend/features/Fde/types'
import { fdeRoutes } from '@/frontend/features/Fde/routes'

function DecisionsPage(props: DecisionsProps) {
  const [decision, setDecision] = useState<Decision | null | 'new'>(null)
  const [projectDialog, setProjectDialog] = useState<{ open: boolean; project: Project | null }>({ open: false, project: null })
  const actions = <ProjectControls path={fdeRoutes.outcomes} project={props.project} projects={props.project_history} copy={props.copy} canManage={props.can_manage} onEdit={() => setProjectDialog({ open: true, project: props.project })} onNew={() => setProjectDialog({ open: true, project: null })} />

  return (
    <>
      <Head title={props.page_title} />
      <FdeShell copy={props.copy} eyebrow={props.copy.decisions.eyebrow} title={props.project?.name ?? props.copy.decisions.title} description={props.copy.decisions.description} actions={actions} projectId={props.project?.id}>
        <ForgeStage props={props} primaryLabel={props.copy.navigation.outcomes} refreshProps={['decisions']} renderPrimary={(headerActions) => (
          <ForgePane title={props.copy.decisions.title} description={props.copy.decisions.description} headerActions={headerActions} actions={props.can_manage && props.project && <Button size="sm" onClick={() => setDecision('new')}><Plus />{props.copy.decisions.new}</Button>}>
            <div className="h-full min-h-0 overflow-y-auto overscroll-contain bg-muted/20 [scrollbar-gutter:stable]"><DecisionLog decisions={props.decisions} projectId={props.project!.id} copy={props.copy} canManage={props.can_manage} onEdit={setDecision} /></div>
          </ForgePane>
        )} />
      </FdeShell>
      {props.project && <DecisionEditorDialog open={decision !== null} onOpenChange={(open) => { if (!open) setDecision(null) }} decision={decision === 'new' ? null : decision} projectId={props.project.id} copy={props.copy} />}
      <ProjectDialog open={projectDialog.open} onOpenChange={(open) => setProjectDialog((current) => ({ ...current, open }))} project={projectDialog.project} agents={props.agents} copy={props.copy} activeProjectId={props.project?.id} />
    </>
  )
}

DecisionsPage.layout = (page: React.ReactElement) => <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
export default DecisionsPage
